import { API_ENDPOINTS, axiosDefaultHeaders } from '@/api/api-config';
import type { Locale } from '@/basket/types/locale';
import type { SiteId } from '@/basket/types/site';
import axios from 'axios';

export const getBaseAxiosInstance = (
  locale: Locale,
  siteId: SiteId,
  abTests?: string | undefined,
  removeSiteId?: boolean,
) => {
  //TODO: Remove the removeSiteId Prop when backend will fix email sending
  return axios.create({
    baseURL: removeSiteId
      ? `${API_ENDPOINTS.BASE}`
      : `${API_ENDPOINTS.BASE}/${siteId}`,
    headers: {
      ...axiosDefaultHeaders(locale),
      'X-AbTests': abTests,
    },
  });
};

export const getReviewsAxiosInstance = (
  locale: Locale,
  abTests?: string | undefined,
) => {
  return axios.create({
    baseURL: API_ENDPOINTS.REVIEWS,
    headers: {
      ...axiosDefaultHeaders(locale),
      'X-AbTests': abTests,
      'x-emoti-origin': 'user',
    },
  });
};
